export default __webpack_public_path__ + "static/media/task-message-outline.6f2d1779.svg";